import { Drawer, Grid } from "@mui/material"
import { BasePathProvider } from "components/Providers"
import PunchApprovalIndex from "./List"
import { useNavigate, useParams } from "react-router-dom"
import PunchApprovalFormIndex from "./Form"

function PunchApprovalsPage() {
    const basePath = `/leave-request/punch-approvals`
    const navigate = useNavigate()
    const { id } = useParams()

  return (
    <BasePathProvider value={`${basePath}`}>
        <Grid container spacing={2} sx={{p: 1, pt: 3}}>
            <PunchApprovalIndex />
            <Drawer
                PaperProps={{
                    sx: {
                        width: 800,
                    }
                }}
                open={Boolean(id)}
                anchor="right"
                onClose={() => navigate(basePath)}
            >
                <PunchApprovalFormIndex />
            </Drawer>
        </Grid>
    </BasePathProvider>
  )
}

export default PunchApprovalsPage